import { css } from 'styled-components';

import { type Theme } from '@/utils/theme/themes';

export const styles = {
  s: 'text-s',
  base: 'text-base',
  m: 'text-m',
  l: 'text-l',
  xl: 'text-xl',
  mono: 'mono',
  annotation: 'annotation'
};

export const TextDeclarations = css<{ theme?: Theme }>`
  .${styles.s} {
    font-size: ${({ theme }) => theme.fontSize.body.s};
    line-height: ${({ theme }) => theme.lineHeight.body.s};
    font-weight: ${({ theme }) => theme.fontWeight.NORMAL};
  }

  .${styles.base} {
    font-size: ${({ theme }) => theme.fontSize.body.base};
    line-height: ${({ theme }) => theme.lineHeight.body.base};
    font-weight: ${({ theme }) => theme.fontWeight.body};
  }

  .${styles.m} {
    font-size: ${({ theme }) => theme.fontSize.body.m};
    line-height: ${({ theme }) => theme.lineHeight.body.m};
    font-weight: ${({ theme }) => theme.fontWeight.body};
  }

  .${styles.l} {
    font-size: ${({ theme }) => theme.fontSize.LARGE};
    line-height: ${({ theme }) => theme.lineHeight.body.l};
    font-size: calc(20rem / 16);
    font-weight: ${({ theme }) => theme.fontWeight.LIGHT};
  }

  .${styles.xl} {
    font-size: ${({ theme }) => theme.fontSize.body.xl};
    line-height: ${({ theme }) => theme.lineHeight.body.xl};
    font-weight: ${({ theme }) => theme.fontWeight.LIGHT};
  }

  .${styles.mono} {
    font-family: ${({ theme }) => theme.fontFamily.MONO_ALT};
    font-weight: ${({ theme }) => theme.fontWeight.mono};
  }

  .${styles.annotation} {
    font-family: ${({ theme }) => theme.fontFamily.MONO_ALT};
    font-weight: ${({ theme }) => theme.fontWeight.mono};
    font-size: ${({ theme }) => theme.fontSize.annotation};
    letter-spacing: ${({ theme }) => theme.letterSpacing.annotation};
    line-height: ${({ theme }) => theme.lineHeight.body.base};
  }
`;
